import cx from 'classnames';
import React, { useRef, useEffect } from 'react';
import styles from './navigation-rail.module.css';
import useNavRailScroll from '../../hooks/use-nav-rail-scroll';
import type { useNavigationRailVm } from '../../hooks/use-navigation-rail-vm';
import CancelOrderSection from '../sections/cancel-order-section';
import NavigationSection from '../sections/navigation-section';
import VehicleSection from '../sections/vehicle-section';

interface NavigationRailProps {
  vm: ReturnType<typeof useNavigationRailVm>;
}

let lastStepName = '';

const NavigationRail: React.FC<NavigationRailProps> = ({ vm }) => {
  const navRailRef = useRef<HTMLElement>(null);

  const {
    vehicle,
    orderedSteps,
    latestStep,
    sectionsArray,
    route,
    pathname,
    stepUrlMap,
    isRailVisible,
    getSectionStatusMappings,
    handleEditClick,
    handleCancelClick,
    handleStepClick,
    routeNameComponentLookup,
    currentSection,
    viewedSection
  } = vm;

  useEffect(() => {
    if (pathname !== '/next-step') {
      lastStepName = pathname;
    }
  }, [pathname]);

  const isNextStepRoute = pathname === '/next-step';
  const effectivePathname = isNextStepRoute ? lastStepName || pathname : pathname;

  useNavRailScroll({ latestStep, navRailRef });

  if (!isRailVisible) {
    return null;
  }

  return (
    <aside
      ref={navRailRef}
      className={cx(styles.navigationRail, isNextStepRoute && styles.noScroll)}
    >
      <VehicleSection vehicle={vehicle} />
      {sectionsArray.map(section => (
        <NavigationSection
          key={section.sectionNumber}
          sectionName={section.sectionName}
          sectionNumber={section.sectionNumber}
          steps={section.steps}
          latestStep={latestStep}
          pathname={effectivePathname}
          stepUrlMap={stepUrlMap}
          route={route}
          statusMappings={getSectionStatusMappings(section.sectionName)}
          routeNameComponentLookup={routeNameComponentLookup}
          currentSection={currentSection}
          handleEditClick={handleEditClick}
          handleStepClick={handleStepClick}
          allSteps={orderedSteps}
          allSections={sectionsArray}
          viewedSection={viewedSection}
        />
      ))}
      <CancelOrderSection handleCancelClick={handleCancelClick} />
    </aside>
  );
};

export default NavigationRail;
